import Type from "@/model/types/Type";

const type = {
    OCCURRENCE_NEW : 1,
    OCCURRENCE_PENDING : 2,
    OCCURRENCE_CLOSE : 3,
}

const list = [
    {
        value: type.OCCURRENCE_NEW,
        text: "Nova",
    },
    {
        value: type.OCCURRENCE_PENDING,
        text: "Em Andamento",
    },
    {
        value: type.OCCURRENCE_CLOSE,
        text: "Finalizada",
    },
]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}


